// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"272":"collectPortalConfig","960":"collectEmailConfig"}[chunkId] || chunkId) + "." + {"160":"5744884d","164":"46aba17b","245":"7e2ec7dd","272":"126987ea","300":"114e8880","330":"a185304c","960":"c8bf8a4e"}[chunkId] + ".css";
};